import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FundAccessGuard } from './_core/guards/fund-access.guard';
import { Configuration } from './app.constants';

@NgModule({
  imports: [CommonModule],
  providers: [Configuration, FundAccessGuard],
})
export class PortalModule {}
